export default __webpack_public_path__ + "static/media/large-crumb1.2f1356e3.png";